import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_STORE](state, payload) {
    state.store = payload;
  },
  [MutationsType.SET_STORES](state, payload) {
    state.stores = payload;
  },
  [MutationsType.ADD_STORE](state, payload) {
    if (state.stores) state.stores.unshift(payload);
  },
  [MutationsType.UPDATE_STORE](state, payload) {
    let ind = (state.stores || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.stores, ind, payload);
  },
  [MutationsType.DELETE_STORE](state, payload) {
    let ind = (state.stores || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.stores, ind);
  },
};
